import { Component, EventEmitter, Input, Output } from '@angular/core';
import { chevronDownIcon, chevronUpIcon, SVGIcon } from '@progress/kendo-svg-icons';
import { ExpansionPanelModule } from '@progress/kendo-angular-layout';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'qpoint-expansion-panel',
    templateUrl: './expansion-panel.component.html',
    styleUrls: ['./expansion-panel.component.scss'],
    imports: [
        CommonModule,
        ExpansionPanelModule
    ]
})
export class QPointExpansionPanelComponent {
  @Input()
  title: string;

  @Input()
  subtitle: string;

  @Input()
  disabled: boolean;

  @Input()
  expanded: boolean;

  @Input()
  storageIdentifier: string;

  @Output() expandedStateChanged = new EventEmitter<boolean>();

  expandIcon: SVGIcon = chevronDownIcon;
  collapseIcon: SVGIcon = chevronUpIcon;

  public onExpandedChange(expanded: boolean) {
    this.expanded = expanded;
    this.expandedStateChanged.emit(expanded);
  }
}

